
<div class="floatinghead be-tab-02 clearfix cf">
  <ul class="nav nav-tabs margin-bottom-20">
    <li class="nav-item">
      <a [class.active]="dashboardActiveTab == markettingTab.Dashboard" href="javascript:void(0);" (click)="onDashboardTabClick(markettingTab.Dashboard);" class="nav-link active">
        Dashboard
      </a>
    </li>
    <li class="nav-item" *ngIf="property.ShowProspectToSeller || prospectTabVisibility">
      <a [class.active]="dashboardActiveTab == markettingTab.Prospects" href="javascript:void(0);" (click)="onDashboardTabClick(markettingTab.Prospects);" class="nav-link">
        Prospects
      </a>
    </li>
    <li class="nav-item">
      <a [class.active]="dashboardActiveTab == markettingTab.Files" href="javascript:void(0);" (click)="onDashboardTabClick(markettingTab.Files);" class="nav-link">
        Files
      </a>
    </li>
  
    <li class="nav-item">
      <a [class.active]="dashboardActiveTab == markettingTab.Contacts" href="javascript:void(0);" (click)="onDashboardTabClick(markettingTab.Contacts);" class="nav-link">
         Contacts
      </a>
    </li>
   
  </ul>
</div>

<!--{{property | json}}-->
<div class="row margin-bottom-50">
  <div class="col-md-12">
    <div *ngIf="dashboardActiveTab == markettingTab.Dashboard">
      <div *ngIf="!isDashboardEnabled" class="tabheadingsoverflow">
        Property Dashboard will be enabled when the property is off-market
      </div>
      <div *ngIf="isDashboardEnabled" class="tabheadingsoverflow">
        <app-dashboard [propertyGuid]="property.Guid" [propertyId]="propertyId" [property]="property" [offerstatusid]="offerstatusid" (loadProspectTab)="loadProspect($event)" (showPlaceOffer)="showPlaceOffer($event)"[isFromPortfolio]="this.property.PropertyStatus == 'Off-Market' && !dashboardTabVisibility"></app-dashboard>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div *ngIf="dashboardActiveTab == markettingTab.Files">
      <app-portfolio-files [source]="'Details'" [propertyId]="propertyId" [UserGuid]="UserGuid"></app-portfolio-files>
    </div>
  </div>
  <div class="col-md-12">
    <div *ngIf="dashboardActiveTab == markettingTab.Prospects">
      <div class="tabheadingsoverflow">
        <app-prospects [propertyId]="property.Id" [IsPortfolio]="false" [property]="property" [isFromDashboard]="false" [propsectMennuId]="propsectMennuId"></app-prospects>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div *ngIf="dashboardActiveTab == markettingTab.Contacts">
      <app-property-contact [DataEntryPropertyId]="propertyId" [UserGuid]="UserGuid"></app-property-contact>
    </div>
  </div>
 
</div>

